/* KLIENTSKÉ VÝSTUPY VE VŠECH JAZYCÍCH (24. 10. 2026) — klíčem je ČESKÝ TEXT.
 * Poznámky, které plánovací engine (lib/planSolver.js) skládá česky do `pozn`
 * u cílů a jednorázových vkladů. Engine je nemění (hlídají ho golden testy);
 * překládají se až při vykreslení přes TL() v ReseniCilu a ShrnutiRozdelovnik.
 * Mechanismus jako data/prekladyUI.rezervace.data.js; samostatný soubor, protože
 * velký slovník souběžně mění jiné týmy. Slučuje lib/prekladyUI.js (velký má přednost).
 * ⚠️ ŽÁDNÉ ASCII uvozovky uvnitř textu (CLAUDE.md, pravidlo 1).
 */
export const PREKLADY_VYSTUPY = {
  "rezerva se doplňuje z přebytku — běžný účet zatím neinvestujeme": {
    sk: "rezerva sa dopĺňa z prebytku — bežný účet zatiaľ neinvestujeme",
    en: "the reserve is topped up from the surplus — the current account is not invested yet",
    uk: "резерв поповнюється з надлишку — поточний рахунок поки не інвестуємо",
    vi: "quỹ dự phòng được bổ sung từ thặng dư — tài khoản thanh toán chưa đầu tư",
  },
  "vklad až po začátku čerpání renty": {
    sk: "vklad až po začiatku čerpania renty",
    en: "the deposit arrives only after the income for life starts",
    uk: "внесок лише після початку виплати ренти",
    vi: "khoản nộp chỉ đến sau khi bắt đầu nhận dòng tiền hưu trí",
  },
  "vklad dorazí až po cílovém datu": {
    sk: "vklad príde až po cieľovom dátume",
    en: "the deposit arrives only after the target date",
    uk: "внесок надійде лише після цільової дати",
    vi: "khoản nộp chỉ đến sau ngày mục tiêu",
  },
};
